function debounce(func, wait, immediate = false) {
		let timeoutId = null;
		return function(...args) {
			const context = this;
			const later = () => {
			timeoutId = null;
			if (!immediate) func.apply(context, args);
			};

			const shouldCallNow = immediate && !timeoutId;
			clearTimeout(timeoutId);
			timeoutId = setTimeout(later, wait);

			if (shouldCallNow) func.apply(context, args);
		};
	}
const bindHeaderEvent =  ()=> {
    
      const boxMenu = document.querySelector('.box__menu');
    const boxClose = document.querySelector('.box__close');
    const menuMobile = document.querySelector('.header__menu .header__menu__mobile');
    // 为 boxMenu 添加点击事件监听器
    boxMenu.addEventListener('click', function() {
        // 隐藏 boxMenu
        boxMenu.style.display = 'none';
        // 显示 boxClose
        boxClose.style.display = 'block';
        menuMobile.style.display = 'block';
    });

    // 为 boxClose 添加点击事件监听器（可选：点击 boxClose 时显示 boxMenu）
    boxClose.addEventListener('click', function() {
        // 显示 boxMenu
        boxMenu.style.display = 'block';
        // 隐藏 boxClose
        boxClose.style.display = 'none';
        menuMobile.style.display = 'none';
    });

    // 选择所有 class 为 plus 的元素
    const plusElements = document.querySelectorAll('.header__menu .plus');

    // 为每个 plus 元素添加点击事件监听器
    plusElements.forEach(plusElement => {
        plusElement.addEventListener('click', function() {
            // 隐藏当前点击的 plus 元素
            plusElement.style.display = 'none';

            // 显示其兄弟元素中 class 为 minus 的元素
            const minusElement = plusElement.nextElementSibling;
            if (minusElement && minusElement.classList.contains('minus')) {
                minusElement.style.display = 'inline'; // 或者是 'block'，根据你的布局需求
            }

            // 显示其父级元素的兄弟元素中 class 为 first 的元素
            const parent = plusElement.parentElement;
            // const firstElement = parent.nextElementSibling;
            // console.log('parent.nextElementSibling',parent.nextElementSibling)
            // if (firstElement && firstElement.classList.contains('first')) {
            //     firstElement.style.display = 'block'; // 根据你的布局需求调整
            // }

            let current = parent.nextElementSibling;
            while (current) {
                if (current.classList.contains('first')) {
                    current.style.display = 'block';
                }
                current = current.nextElementSibling;
            }
        });
    });
    // 选择所有 class 为 minus 的元素
    const minusElements = document.querySelectorAll('.header__menu .minus');

    // 为每个 minus 元素添加点击事件监听器
    minusElements.forEach(minusElement => {
        minusElement.addEventListener('click', function() {
            // 显示其兄弟元素中 class 为 plus 的元素
            const plusElement = minusElement.previousElementSibling;
            if (plusElement && plusElement.classList.contains('plus')) {
                plusElement.style.display = 'inline'; // 或者是 'block'，根据你的布局需求
            }

            // 隐藏当前点击的 minus 元素
            minusElement.style.display = 'none';

            // 隐藏其父级元素的兄弟元素中 class 为 first 的元素
            const parent = minusElement.parentElement;
            // const firstElement = parent.nextElementSibling;
            // if (firstElement && firstElement.classList.contains('first')) {
            //     firstElement.style.display = 'none'; // 根据你的布局需求调整
            // }
            let current = parent.nextElementSibling;
            while (current) {
                if (current.classList.contains('first')) {
                     current.style.display = 'none'; // 根据你的布局需求调整
                }
                current = current.nextElementSibling;
            }
        });
    });

    bindMouseHoverNavChangeImg()
}

const bindMouseHoverNavChangeImg = ()=>{
  
    const productNavItems = document.querySelectorAll(' .box__product .nav__item .nav__item__second'); 
    productNavItems.forEach(productNavItem => { 
        const currentImg = productNavItem.querySelector('img');
        const originImgUrl = currentImg.src;
        const hoverContainerDom = productNavItem.querySelector('.item__name')
         let currentImgUrl = ''
        const callbackFn = debounce(function(e) { 
            const tempUrl = e.srcElement.dataset?.img
            if (currentImgUrl!==tempUrl&&tempUrl) {
                currentImgUrl = tempUrl
                currentImg.src = tempUrl
            }
        },50)
        const onLeave = debounce(()=>{
            currentImg.src = originImgUrl
            currentImgUrl = originImgUrl
        },80)
        hoverContainerDom.addEventListener('mousemove', callbackFn);

        hoverContainerDom.addEventListener('mouseleave', onLeave);
    });
    

}

const renderHeader = ()=>{
    const header = document.querySelector('.header');
    let headerHtml = 
    `
         
    <div class="top-bar">
        <a href="https://www.aidot.com/new-user-zone?utm_term=Linkind-new-user">
            New users only: first order starting from $2.99 >>>
        </a>
    </div>

    <div class="header__menu">
        <div class="header__menu__box container">
            <div class="menu__box__content">
                <div class="menu__box__left">
                    <button id="box-menu">
                        <img class="box__menu" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/menu.svg?v=1762422600" alt="">
                        <img class="box__close" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/close.svg?v=1762422610" alt="">
                    </button>
                    <a href="/" style="display: flex;"><img class="box__logo" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/logo.svg?v=1762422621" alt=""></a>
                </div>
                <div class="menu__box__middle">
                    <ul>
                        <li class="box__product" style="cursor: unset;">
                            <a style="cursor: pointer;" href="/products">Products</a>
                            <div class="level-top mouse-event">
                                <div class="menu__category__nav">
                                    <div class="nav__item first">
                                        <div class="nav__item__first"></div>
                                    </div>
                                    <div class="nav__item">
                                        <a class="nav__item__first" href="/products/essential-lighting.html">
                                            <span>Essential Lighting</span>
                                        </a>
                                        <div class="nav__item__second" style="padding-left: 40px;">
                                            <img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Matter_Compatible.png?v=1762422729" alt="" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Matter_Compatible.png?v=1762422729">
                                            <div class="item__name">
                                                <a href="/products/essential-lighting/smart-bulbs.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Matter_Compatible_1.png?v=1762422767">Smart Bulbs</a>
                                                <a href="/products/essential-lighting/traditional-bulbs.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Non-Matter_Compatible.png?v=1762422792">Traditional Bulbs</a>
                                                <a href="/products/essential-lighting/smart-accessories.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Matter_Compatible_2.png?v=1762422823">Smart Accessories</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="nav__item">
                                        <a class="nav__item__first" href="/products/outdoor-lighting.html">
                                            <span>Outdoor Lighting</span>
                                        </a>
                                        <div class="nav__item__second" style="padding-left: 40px;">
                                            <img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Landscape_Lights.png?v=1762422863" alt="" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Landscape_Lights.png?v=1762422863">
                                            <div class="item__name">
                                                <a href="/products/outdoor-lighting/spotlights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Landscape_Lights_1.png?v=1762422889">Spotlights</a>
                                                <a href="/products/outdoor-lighting/pathway-lights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Landscape_Lights_2.png?v=1762422899">Pathway Lights</a>
                                                <a href="/products/outdoor-lighting/wall-lights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Landscape_Lights_3.png?v=1762422907">Wall Lights</a>
                                                <a href="/products/outdoor-lighting/pool-lights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/pool-light.png?v=1762422916">Pool Lights</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="nav__item">
                                        <a class="nav__item__first" href="/products/entertainment-lighting.html">
                                            <span>Entertainment Lighting</span>
                                        </a>
                                        <div class="nav__item__second" style="padding-left: 40px;">
                                            <img src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/TV_Light_Strip.png?v=1762422972" alt="" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/TV_Light_Strip.png?v=1762422972">
                                            <div class="item__name">
                                                <a href="/products/entertainment-lighting/tv-backlights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/TV_Light_Strip_1.png?v=1762422988">TV Backlights</a>
                                                <a href="/products/entertainment-lighting/strip-lights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/TV_Light_Strip_2.png?v=1762422995">Strip Lights</a>
                                                <a href="/products/entertainment-lighting/panel-lights.html" data-img="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/panel-lights-2x.png?v=1762423006">Panel Lights</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="nav__item last">
                                        <div class="nav__item__first"></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li>
                            <a href="/pages/matter">Matter</a>
                        </li>
                        <li>
                            <a href="/pages/app">App</a>
                        </li>
                        <li>
                            <a href="/pages/about-us">About</a>
                        </li>
                        <li>
                            <a href="https://www.linkind.com/blog" target="_blank">Blog</a>
                        </li>
                        <!-- <li class="box__product">
                            <a href="/pages/support">Support</a>
                            <div class="level-top" style="right: unset;left: unset;white-space: nowrap;min-width: 175px;max-width: 178px;max-height: 130px;">
                                <div class="menu__category__nav">
                                    <div class="nav__item">
                                        <div class="nav__item__second">
                                            <div class="item__name">
                                                <a href="/pages/support">Product Support</a>
                                                <a href="/pages/warranty">Warranty Policy</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li> -->
                        <li class="box__product">
                            <a href="javascript:void(0);" style="cursor: default;">Technology</a>
                            <div class="level-top" style="right: unset;left: unset;white-space: nowrap; width: 442px; transform: translateX(-40%);">
                                <div class="menu__category__nav">
                                    <div class="nav__item" style="width: 100%;">
                                        <div class="nav__item__second" style="padding:24px 0;">
                                            <div class="item__name" style="display: flex; flex-wrap: wrap;flex-direction: row; justify-content: start; gap: 10px ; padding: 0 24px; cursor: auto;">
                                                    <a href="/pages/solardot.html" class="technology-logo"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/SolarDot2.png?v=1762423775" alt="SolarDot Logo" class="logo"></a>
                                                    <a href="/pages/aurascape.html" class="technology-logo" target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/AuraScape2.png?v=1762423763" alt="AuraScape Logo" class="logo"></a>
                                                    <a href="/pages/lumisync.html" class="technology-logo"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/LumiSync2.png?v=1762423787" alt="LumiSync Logo" class="logo"></a>
                                                    <a href="/pages/dotis.html" class="technology-logo"  target="_blank"  ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Dotis2.png?v=1762423798" alt="Dotis Logo" class="logo"></a>
                                                    <a href="/pages/immerspace.html" class="technology-logo"  target="_blank"  ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/ImmerSpace2.png?v=1762423812" alt="ImmerSpace Logo" class="logo"></a> 
                                                </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="menu__box__right">
                    <ul><li>
                        <a class="box__shop" href="javascript:void(0);" onclick="event.preventDefault(); window.aidotCartDrawer && window.aidotCartDrawer.open()" target="_blank">
                            <img class="box__arrow__down" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/shopping.svg?v=1762423079" alt="">
                            <span class="counter qty" id="header-cart-counter"><span class="counter-number" id="header-cart-counter-number"></span><span class="counter-label">1</span></span>
                            <p>Store</p>
                        </a>
                    </li>
                        <li class="box__search">
                            <img class="box__arrow__down" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/search.svg?v=1762422543" alt="">
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="header__menu__mobile">
            <div class="content__box">
                <div class="header__menu__mobile__item item__extend">
                    <dt>
                        <a href="/products">
                            Products                            </a>
                        <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                        <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt="">
                    </dt>
                    <dd class="first">
                        <dl>
                            <dt><a href="/products/essential-lighting.html">Essential Lighting</a>
                                <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                                <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt=""></dt>
                            <dd class="second"><a href="/products/essential-lighting/smart-bulbs.html">Smart Bulbs</a></dd>
                            <dd class="second"><a href="/products/essential-lighting/traditional-bulbs.html">Traditional Bulbs</a></dd>
                            <dd class="second"><a href="/products/essential-lighting/smart-accessories.html">Smart Accessories</a></dd>
                        </dl>
                    </dd>
                    <dd class="first">
                        <dl>
                            <dt><a href="/products/outdoor-lighting.html">Outdoor Lighting</a>
                                <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                                <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt=""></dt>
                            <dd class="second"><a href="/products/outdoor-lighting/spotlights.html">Spotlights</a></dd>
                            <dd class="second"><a href="/products/outdoor-lighting/pathway-lights.html">Pathway Lights</a></dd>
                            <dd class="second"><a href="/products/outdoor-lighting/wall-lights.html">Wall Lights</a></dd>
                        </dl>
                    </dd>
                    <dd class="first">
                        <dl>
                            <dt><a href="/products/entertainment-lighting.html">Entertainment Lighting</a>
                                <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                                <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt=""></dt>
                            <dd class="second"><a href="/products/entertainment-lighting/tv-backlights.html">TV Backlights</a></dd>
                            <dd class="second"><a href="/products/entertainment-lighting/strip-lights.html">Strip Lights</a></dd>
                            <dd class="second"><a href="/products/entertainment-lighting/panel-lights.html">Panel Lights</a></dd>
                        </dl>
                    </dd>
                </div>
                <div class="header__menu__mobile__item">
                    <dt><a class="item__matter" href="/matter">Matter</a></dt>
                </div>
                <div class="header__menu__mobile__item">
                    <dt><a class="item__app" href="/app">App</a></dt>
                </div>
                <div class="header__menu__mobile__item">
                    <dt><a class="item__about" href="/pages/about-us">About</a></dt>
                </div>
                <div class="header__menu__mobile__item">
                    <dt><a class="item__about" href="/blog">Blog</a></dt>
                </div>
                <!--<div class="header__menu__mobile__item">
                    <dt><a class="item__support" href="/support">Support</a></dt>
                </div>-->
                  <!-- <div class="header__menu__mobile__item item__extend">
                    <dt>Support
                        <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                        <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt="">
                    </dt>
                    <dd class="first">
                        <dl>
                            <dt><a href="/support">Product Support</a></dt>
                            <dt><a href="/warranty">Warranty Policy</a></dt>
                        </dl>
                    </dd>
                </div> -->
                <div class="header__menu__mobile__item item__extend">
                    <dt>Technology
                        <img class="plus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_plus.svg?v=1762422447" alt="">
                        <img class="minus" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/common-footer-icon_minus.svg?v=1762422503" alt="">
                    </dt>
                    <dd class="first" style="padding:0 min(32px, 4.266666vw);">
                        <dl class="mobile—technology-logo-container" >
                             <a class="mobile—technology-logo" href="/pages/solardot.html"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/SolarDot.png?v=1762423481" alt="SolarDot Logo" class="logo"></a>
                             <a class="mobile—technology-logo" href="/pages/aurascape.html" target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/AuraScape.png?v=1762423492" alt="AuraScape Logo" class="logo"></a>
                             <a class="mobile—technology-logo" href="/pages/lumisync.html"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/LumiSync.png?v=1762423503" alt="LumiSync Logo" class="logo"></a>
                             <a class="mobile—technology-logo" href="/pages/dotis.html"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/Dotis.png?v=1762423525" alt="Dotis Logo" class="logo"></a>
                             <a class="mobile—technology-logo" href="/pages/immerspace.html"  target="_blank" ><img  src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/ImmerSpace.png?v=1762423525" alt="ImmerSpace Logo" class="logo"></a>
                        </dl>
                    </dd>
                </div>
            </div>
        </div>

        <div class="header__menu__search">
            <div class="header__search__box container">
                <img class="search__search" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/search.svg?v=1762422543" alt="">

                <form class="form minisearch" id="search_mini_form" action="/catalogsearch/result/" method="get">
                    <input id="input-search" type="text" name="q" value="" placeholder="Search" class="header_nav_search_input" maxlength="128" role="combobox" aria-haspopup="false" aria-autocomplete="both" autocomplete="off" aria-expanded="false">
                    <div class="actions">
                        <button type="submit" title="Search" class="action search" aria-label="Search" disabled="">
                            <span>Search</span>
                        </button>
                    </div>
                </form>

                <img class="search__close" src="https://cdn.shopify.com/s/files/1/0689/4079/1878/files/close.svg?v=1762422610" alt="">
            </div>
        </div>
    </div>

    
    `
    header.innerHTML = headerHtml
}
function bandingSearchEvent() {
  
        const defaultContainer = document.querySelector('.header__menu__box')
        const searchContainer = document.querySelector('.header__menu__search')
        const search_icon = document.querySelector('.box__search .box__arrow__down')
        const search_close = document.querySelector('.header__search__box .search__close')
        const searchInputDom  = document.querySelector('#input-search')


        const updataShowSearch = (flag)=>{
          if (flag) {
            defaultContainer.style.display = 'none'
            searchContainer.style.display = 'block'
            
          }else{
            defaultContainer.style.display = 'block'
            searchContainer.style.display = 'none'
          }
        }

        search_icon.addEventListener('click',()=>{
          updataShowSearch(true)
        })

        search_close.addEventListener('click',()=>{
          updataShowSearch(false)
          searchInputDom.value = ''
        })

        searchInputDom.addEventListener('keydown', function (event) {
          if ((event.key === 'Enter' || event.keyCode === 13)&&searchInputDom.value!=='') {
            console.log('回车键触发了！');
            // 这里写你需要执行的逻辑
            location.href = '/search/?type=product&q='+searchInputDom.value
          }
        });
      }
const initHeader = ()=>{
    //renderHeader()
    bindHeaderEvent()
    bandingSearchEvent()
}
initHeader()